(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[158],{

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 35161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 1903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ IMAGE_SIZE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);


var IMAGE_SIZE = {
    XS: "xs",
    XS_WEBP: "xs-webp",
    MD: "md",
    MD_WEBP: "md-webp",
    LG: "lg",
    LG_WEBP: "lg-webp",
    XL: "XL",
    XL_WEBP: "xl-webp",
    XXL: "XXL",
    XXL_WEBP: "xxl-webp"
};
var Image = function(param) {
    var _src = param.src, src = _src === void 0 ? "" : _src, alt = param.alt, title = param.title, _external = param.external, external = _external === void 0 ? false : _external, size = param.size, _externalLink = param.externalLink, externalLink = _externalLink === void 0 ? "" : _externalLink, _className = param.className, className = _className === void 0 ? "" : _className, width = param.width, height = param.height, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _decoding = param.decoding, decoding = _decoding === void 0 ? "async" : _decoding, fetchPriority = param.fetchPriority;
    var imgUrl = external ? externalLink ? "".concat(externalLink).concat(src) : "".concat(src) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_IMG */ .T).concat(src);
    var source = "".concat(imgUrl, "?x-image-process=style/").concat(size || "lg-webp");
    var altText = alt !== null && alt !== void 0 ? alt : title;
    var images = // display:block + width:100% so the img has a width to resolve against → its CSS aspect-ratio
    // can reserve space BEFORE the image loads (an inline <picture> collapses to 0 and causes CLS).
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        className: "resolution-image",
        style: {
            display: "block",
            width: "100%"
        },
        children: [
            !size && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(imgUrl, "?x-image-process=style/xs-webp"),
                media: "(max-width: 450px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(imgUrl, "?x-image-process=style/md-webp"),
                media: "(max-width: 690px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: source,
                media: "(min-width: 691px)",
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: className,
                src: source,
                title: altText || "image",
                alt: altText,
                width: width,
                height: height,
                loading: loading,
                decoding: decoding,
                fetchPriority: fetchPriority
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "lazyload-wrapper",
        style: {
            width: "100%"
        },
        children: images
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 30158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SectionHomepageOne; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35161);
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15072);
/* harmony import */ var src_utils_devices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97348);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(186);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1903);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: grid;\n  grid-template-columns: 2.5fr 1fr 1fr;\n  grid-template-rows: 1fr;\n  grid-template-areas: 'block-1 block-2 block-3';\n  grid-gap: 20px;\n  padding: 15px;\n  height: 599px;\n  /* Let the img's width/height attributes (16:9) reserve space pre-load (avoids CLS).\n     card-byline sets height:100% which makes the CSS aspect-ratio ambiguous; auto makes it authoritative. */\n  .card-image img {\n    height: auto;\n  }\n  .block-1 {\n    grid-area: block-1;\n    min-height: 0;\n    overflow: hidden;\n    .card-image {\n      border-radius: 8px;\n    }\n    .card-title {\n      font-size: 26pt;\n      line-height: 1;\n      letter-spacing: 0;\n    }\n    .card-blurb {\n      -webkit-line-clamp: 2 !important;\n    }\n  }\n  .block-2 {\n    grid-area: block-2;\n    flex-direction: column;\n    gap: var(--gap);\n    min-height: 0;\n    overflow: hidden;\n    .card-image {\n      border-radius: 8px;\n    }\n    .card-title {\n      font-size: 20pt;\n      font-family: 'DBHelvethaicaXBd', sans-serif;\n      font-weight: 500;\n      line-height: 1;\n      letter-spacing: 0;\n      -webkit-line-clamp: 3 !important;\n    }\n  }\n  .block-3 {\n    grid-area: block-3;\n    gap: var(--gap);\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    .block-3-scroll {\n      flex: 1;\n      min-height: 0;\n      overflow-y: auto;\n      display: flex;\n      flex-direction: column;\n      gap: var(--gap);\n\n      /* Scrollbar styling */\n      scrollbar-width: thin;\n      scrollbar-color: #c1c1c1 transparent;\n      &::-webkit-scrollbar {\n        width: 4px;\n      }\n      &::-webkit-scrollbar-thumb {\n        background-color: #c1c1c1;\n        border-radius: 4px;\n      }\n      &::-webkit-scrollbar-track {\n        background: transparent;\n      }\n      .card-title {\n        a {\n          cursor: default;\n          pointer-events: none;\n        }\n      }\n    }\n\n    .text-ellipsis-2 {\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      -webkit-line-clamp: 2;\n    }\n    .more {\n      display: flex;\n      justify-content: flex-end;\n      cursor: pointer;\n      font-size: 20px;\n      flex-shrink: 0;\n      a {\n        color: #0600e7;\n        &:hover {\n          color: #80abc1;\n        }\n      }\n    }\n  }\n  @media (max-width: 1024px) {\n    grid-template-columns: 1.5fr 1fr;\n    grid-template-rows: auto 1fr;\n    grid-template-areas: 'block-1 block-3' 'block-2 block-3';\n    height: auto;\n    min-height: 545px;\n    .block-2 {\n      flex-direction: row;\n      align-items: flex-start;\n    }\n    .block-3 .block-3-scroll {\n      max-height: 480px;\n    }\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: 1fr;\n    grid-template-areas: 'block-1' 'block-2' 'block-3';\n    grid-template-rows: auto;\n    grid-gap: 0px;\n    padding: 15px 10px;\n    height: auto;\n    min-height: unset;\n\n    .block-1 {\n      overflow: visible;\n      .card-byline {\n        margin-bottom: 15px;\n      }\n      .card-byline a {\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-template-areas: 'card-title' 'card-image' 'footer';\n      }\n      .card-image {\n        grid-area: card-image;\n        border-radius: 8px;\n      }\n      .card-title {\n        grid-area: card-title;\n        font-size: 30pt;\n        display: block;\n        text-align: center;\n        line-height: 1.2;\n        font-weight: 400;\n        letter-spacing: 0;\n      }\n      .footer {\n        grid-area: footer;\n        display: block;\n        text-align: center;\n      }\n    }\n\n    .block-2 {\n      display: block;\n      padding-bottom: 15px;\n      overflow: visible;\n      .card-byline {\n        margin-bottom: 15px;\n      }\n      .card-title {\n        font-size: 20pt;\n      }\n    }\n    .block-1,\n    .block-2 {\n      .card-byline {\n        border-bottom: 1px solid var(--border-blue);\n        padding-bottom: 12px;\n      }\n    }\n    .block-3 {\n      border: 1px solid var(--border-blue);\n      border-top: 0;\n      border-left: 0;\n      border-right: 0;\n\n      .block-3-scroll {\n        max-height: 310px;\n        overflow-y: auto;\n      }\n\n      .card-title {\n        background-color: transparent;\n        font-size: 19pt;\n        padding: 0 0 0 18px;\n        &:before {\n          top: 10px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var WidgetHeading = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(Promise.all(/* import() */[__webpack_require__.e(2777), __webpack_require__.e(2657)]).then(__webpack_require__.bind(__webpack_require__, 2657)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2657)
            ];
        }
    },
    ssr: true
});
var CardByLine = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(__webpack_require__.e(/* import() */ 3614).then(__webpack_require__.bind(__webpack_require__, 23614)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23614)
            ];
        }
    },
    ssr: true
});
var CardTitle = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(__webpack_require__.e(/* import() */ 3481).then(__webpack_require__.bind(__webpack_require__, 63481)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63481)
            ];
        }
    },
    ssr: true
});
function SectionHomepageOne(param) {
    var id = param.id, data = param.data, lastestNews = param.lastestNews, eventDataLayer = param.eventDataLayer, sectionLive = param.sectionLive;
    var ref, ref1, ref2;
    var responsive = (0,src_utils_devices__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var isSectionLive = !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(sectionLive);
    var mapSectionLive = lodash_map__WEBPACK_IMPORTED_MODULE_4___default()(sectionLive.sort(function(a, b) {
        return parseFloat(b.key) - parseFloat(a.key);
    }), function(item) {
        return {
            title: item.value,
            timeline: item.key
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionWrapper, {
        id: id,
        className: "container",
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_6__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "block-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardByLine, {
                    showH2: true,
                    data: data === null || data === void 0 ? void 0 : data.newHighlight[0],
                    showBlurb: false,
                    showBadge: true,
                    imageLoading: "eager",
                    imageFetchPriority: "high",
                    imageWidth: 1280,
                    imageHeight: 720,
                    eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, eventDataLayer), {
                        data: {
                            heading: "HIGHLIGHT",
                            title: (ref = data === null || data === void 0 ? void 0 : data.newHighlight[0]) === null || ref === void 0 ? void 0 : ref.title,
                            block: "1",
                            index: "1"
                        }
                    }),
                    size: _image__WEBPACK_IMPORTED_MODULE_8__/* .IMAGE_SIZE.LG_WEBP */ .W.LG_WEBP,
                    showPublishDate: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "block-2 flex-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardByLine, {
                        data: data === null || data === void 0 ? void 0 : data.newHighlight[1],
                        imageWidth: 1280,
                        imageHeight: 720,
                        showBlurb: false,
                        showByline: false,
                        eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, eventDataLayer), {
                            data: {
                                heading: "HIGHLIGHT",
                                title: (ref1 = data === null || data === void 0 ? void 0 : data.newHighlight[1]) === null || ref1 === void 0 ? void 0 : ref1.title,
                                block: "2",
                                index: "1"
                            }
                        }),
                        showBadge: responsive.isMobile,
                        showPublishDate: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardByLine, {
                        data: data === null || data === void 0 ? void 0 : data.newHighlight[2],
                        imageWidth: 1280,
                        imageHeight: 720,
                        showBlurb: false,
                        showByline: false,
                        eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, eventDataLayer), {
                            data: {
                                heading: "HIGHLIGHT",
                                title: (ref2 = data === null || data === void 0 ? void 0 : data.newHighlight[1]) === null || ref2 === void 0 ? void 0 : ref2.title,
                                block: "2",
                                index: "2"
                            }
                        }),
                        showBadge: responsive.isMobile,
                        showPublishDate: true
                    })
                ]
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(lastestNews) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "block-3 flex-column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetHeading, {
                        heading: "Latest News",
                        link: "/category/latest-news",
                        isSectionLive: isSectionLive
                    }),
                    isSectionLive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "block-3-scroll",
                        children: lodash_map__WEBPACK_IMPORTED_MODULE_4___default()(isSectionLive ? mapSectionLive : lastestNews, function(item, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardTitle, {
                                data: item,
                                eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, eventDataLayer), {
                                    data: {
                                        heading: "Latest News",
                                        title: item === null || item === void 0 ? void 0 : item.title,
                                        block: "3",
                                        index: index + 1
                                    }
                                }),
                                showPublishDate: true,
                                isSectionLive: isSectionLive,
                                sectionLive: sectionLive
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: lodash_map__WEBPACK_IMPORTED_MODULE_4___default()(lastestNews === null || lastestNews === void 0 ? void 0 : lastestNews.slice(0, 4), function(item, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardTitle, {
                                data: item,
                                eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, eventDataLayer), {
                                    data: {
                                        heading: "Latest News",
                                        title: item === null || item === void 0 ? void 0 : item.title,
                                        block: "3",
                                        index: index + 1
                                    }
                                }),
                                showPublishDate: true
                            }, index);
                        })
                    }),
                    !isSectionLive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "more",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            href: "/category/latest-news",
                            children: "อ่านข่าวทั้งหมด"
                        })
                    })
                ]
            })
        ]
    });
};
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject());


/***/ })

}]);